module.exports = __webpack_public_path__ + "images/61199182e45613b7932d163ec9ad823c.svg";